
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'

import Vue from 'vue'

var HomeListCom = Vue.extend({})

Vue.component('home-list', HomeListCom)

export default {
name: 'HomeList',
props: ['baseUrl'],
components: {
Group,
Cell,
CellBox,
Flexbox,
FlexboxItem,
Grid,
GridItem,
GroupTitle
},
methods:{
openChart(){
this.$common.notFound();
}
}
}



// WEBPACK FOOTER //
// ./src/components/home/HomeList.vue